import type { Dictionary } from './dictionary';

/** Slovník RU – převzato z prototypu, doplněné klíče přeloženy ve stejném stylu. */
export const ru: Dictionary = {
  app: 'Склад',
  logoutA: 'Выйти',

  idLbl: 'Номер посылки',
  seq: 'Порядок',
  nav: 'Навигация',
  count: 'Количество посылок',
  weight: 'Вес',
  edit: 'Изменить',
  date: 'Дата',
  driver: 'Водитель',
  vehicle: 'Транспорт',
  zone: 'Зона',
  routeNo: 'Номер маршрута',
  deliveryTime: 'Время',
  scanned: 'Отсканированный код',
  scannedBy: 'Считано складом',
  noWeight: '— кг',
  addWeight: 'Добавить вес',

  until: 'Доставка только',
  dayLbl: 'День доставки',
  notSet: 'Ещё не определён',
  expedFrom: 'Будет отправлено со склада',

  chill: 'ОХЛАЖДЁННОЕ',
  frozen: 'ЗАМОРОЖЕННОЕ',

  trCZ: 'ОТПРАВИТЬ В ЧЕХИЮ',
  trSK: 'ОТПРАВИТЬ В СЛОВАКИЮ',
  trNoteCZ: 'Посылку необходимо перевезти в Чехию.',
  trNoteSK: 'Посылку необходимо перевезти в Словакию.',
  loadToday: 'ЗАГРУЗИТЬ СЕГОДНЯ',
  confirmTr: 'Подтвердить перевозку',
  trValCZ: 'Перевезено в Чехию',
  trValSK: 'Перевезено в Словакию',
  confirmTitle: 'Подтвердить перевозку между складами',
  confirmNote: 'Подтверждением в заказ будет записано: «{W}».',
  notFinal: 'Это не конечное состояние.',

  pkgLbl: 'Место',
  ofN: 'из',
  kompLbl: 'Комплектация заказа',
  kompDone: 'ПОСЫЛКА ПОЛНОСТЬЮ ОТСКАНИРОВАНА',
  kompTodo: 'ЕЩЁ НЕОБХОДИМО ОТСКАНИРОВАТЬ',

  retry: 'Повторная попытка',
  part: 'Доставить вторую часть',

  scanNext: 'Сканировать далее',
  report: 'СООБЩИТЬ ДИСПЕТЧЕРУ',
  reported: 'Сообщено диспетчерам',
  findManual: 'НАЙТИ ВРУЧНУЮ',

  reportTitle: 'Сообщить диспетчеру',
  reasonLbl: 'Причина',
  byState: 'ПО СОСТОЯНИЮ',
  r_zrusena: 'Посылка уже отменена',
  r_dorucena: 'Посылка уже доставлена',
  r_vracena: 'Посылка уже возвращена отправителю',
  r_jiny: 'Другая причина – опиши в примечании',
  noteReq: 'Примечание (обязательно)',
  noteOpt: 'Примечание (необязательно)',
  notePh: 'Напр. посылка повреждена, этикетка нечитаема…',
  send: 'Отправить',
  sending: 'Отправляю…',
  cancel: 'Отмена',
  errReason: 'Выбери причину.',
  errNote: 'Для другой причины добавь примечание.',

  findTitle: 'Найти вручную',
  orderNo: 'Номер заказа',
  orderPh: 'Введи номер заказа',
  search: 'Искать',
  searching: 'Ищу…',
  errQuery: 'Введи номер заказа.',

  loginTitle: 'Вход',
  loginSubtitle: 'Войди, чтобы продолжить',
  loginName: 'Имя',
  loginPin: 'PIN',
  loginSubmit: 'Войти',
  loginPending: 'Вхожу…',
  loginErrEmpty: 'Заполни имя и PIN.',
  loginErrFailed: 'Не удалось войти.',

  scanTitle: 'Сканирование кода',
  scanHint: 'Наведи камеру на QR или штрихкод.',
  scanStart: 'Запустить сканер',
  scanStop: 'Остановить сканер',
  scanStarting: 'Запускаю камеру…',
  scanCameraErr: 'Не удалось запустить камеру.',
  scanLoading: 'Загружаю данные посылки…',
  manualTitle: 'Или введи код вручную',
  manualPh: 'Номер посылки',
  manualSubmit: 'Найти',

  errLoad: 'Не удалось загрузить посылку.',
  retryAction: 'Попробовать снова',
  offline: 'Офлайн – данные могут быть неактуальны',
  queued: 'Будет отправлено после подключения',
  queueFailed: 'Не удалось отправить',
  sendErr: 'Не удалось отправить – попробовать снова',

  weightTitle: 'Исправление веса',
  weightNew: 'Новый вес (кг)',
  weightPh: 'Напр. 15,5',
  weightPhotos: 'Фото (доказательство)',
  weightHint: 'Введи реальный вес и приложи фото как доказательство.',
  weightSave: 'Сохранить вес',
  errWeight: 'Введи корректный вес.',

  routesEntry: 'Обзор маршрутов',
  routesTitle: 'Маршруты',
  routeTitle: 'Маршрут',
  routesLoading: 'Загружаю маршруты…',
  routesErr: 'Не удалось загрузить маршруты.',
  routesForbidden: 'У тебя нет доступа к обзору маршрутов.',
  routesEmpty: 'На этот день маршрутов нет.',
  routesDay: 'День',
  routesToday: 'Сегодня',
  routesMine: 'Мой маршрут',
  routesUnfinishedOnly: 'Только незавершённые',
  routesAll: 'Все',
  routesUnfinishedCount: 'Незавершённые',
  routeShipments: 'Отправлений',
  routeParcels: 'Мест',
  routeLoaded: 'Загружено',
  routeScanned: 'Отсканировано',
  routeNoDriver: 'Без водителя',
  routeBack: 'Назад к маршрутам',
  routeErr: 'Не удалось загрузить маршрут.',
  routeAllDone: 'Весь маршрут загружен.',
  routeToLoad: 'Осталось загрузить',
  routeUnseen: 'Не отсканировано',
  routeNoUnfinished: 'Нет незавершённых отправлений.',
  partialTitle: 'Частично отсканированные отправления',
  partialNoRoute: 'Без маршрута',
  partialLoading: 'Загружаю частично отсканированные отправления…',
  partialBack: 'Назад к сканированию',
  partialHint: 'Заказы, в которых отсканирована только часть посылок. Найди недостающие и отсканируй их.',
  partialEmpty: 'Нет частично отсканированных отправлений.',
  partialErr: 'Не удалось загрузить частично отсканированные отправления.',
  shSender: 'Отправитель',
  'sh.loaded': 'ЗАГРУЖЕНО',
  'sh.notLoaded': 'ОТСКАНИРОВАНО, НЕ ЗАГРУЖЕНО',
  'sh.incomplete': 'НЕ ВСЁ ОТСКАНИРОВАНО И НЕ ЗАГРУЖЕНО',
  'sh.unknown': 'НЕИЗВЕСТНОЕ СОСТОЯНИЕ',
  shMissing: 'Не хватает мест',

  's.preprava.kicker': 'Всё в порядке',
  's.preprava.name': 'Перевозка',
  's.preprava.headline': '',
  's.preprava.sub': 'Посылка в пути по плану.',

  's.schvaleni.kicker': 'Ожидает согласования',
  's.schvaleni.name': 'Согласование перевозки',
  's.schvaleni.headline': 'ЗАВТРА НЕ ЕДЕТ',
  's.schvaleni.sub':
    'Перевозка не согласована, посылка ещё не имеет точного дня доставки. Не добавляй посылку в завтрашний маршрут.',

  's.priprava.kicker': 'Идёт · подготовка',
  's.priprava.name': 'Подготовка посылки',
  's.priprava.headline': '',
  's.priprava.sub': 'Посылка завтра не едет, вероятно будет доставлена позже.',

  's.vraceni.kicker': 'Поедет позже · возвращаем',
  's.vraceni.name': 'Возврат отправителю',
  's.vraceni.headline': '',
  's.vraceni.sub':
    'Посылка завтра не едет, вероятно будет доставлена позже. Это не конечное состояние.',

  's.dokoncena.kicker': 'Конечное состояние · сообщи диспетчеру',
  's.dokoncena.name': 'Завершена',
  's.dokoncena.headline': 'ОШИБКА ПОСЫЛКИ',
  's.dokoncena.sub': 'Заказ уже в конечном состоянии – сообщи диспетчерам.',

  's.zrusena.kicker': 'Конечное состояние · сообщи диспетчеру',
  's.zrusena.name': 'Отменена',
  's.zrusena.headline': 'ОШИБКА ПОСЫЛКИ',
  's.zrusena.sub': 'Заказ уже в конечном состоянии – сообщи диспетчерам.',

  's.vraceno.kicker': 'Конечное состояние · сообщи диспетчеру',
  's.vraceno.name': 'Возвращена отправителю',
  's.vraceno.headline': 'ОШИБКА ПОСЫЛКИ',
  's.vraceno.sub': 'Заказ уже в конечном состоянии – сообщи диспетчерам.',

  's.nenalezena.kicker': 'Кода нет в системе',
  's.nenalezena.name': 'Посылка не найдена',
  's.nenalezena.headline': 'ПОСЫЛКА НЕ НАЙДЕНА',
  's.nenalezena.sub': 'Отсканированный код не найден в системе.',

  's.neznamy.kicker': 'Не распознано · проверь',
  's.neznamy.name': 'Неизвестное состояние',
  's.neznamy.headline': '',
  's.neznamy.sub': 'Это состояние приложению неизвестно. Не продолжай без проверки у диспетчера.',
};
